import { cn } from "@/lib/utils"
import { Undo2Icon } from "lucide-react"

export function RestoreIcon({ className }: { className?: string }) {
  return <Undo2Icon className={cn("text-emerald-600", className)} />
}
